import React, { useState } from 'react';
import { exportService } from '../services/exportService';
import './ExportButton.css';

const ExportButton = ({ 
  type, 
  format, 
  filters = {}, 
  label, 
  icon = 'fas fa-download',
  className = '',
  onSuccess,
  onError,
  productId = null // ID du produit spécifique à exporter
}) => {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    setIsExporting(true);
    
    try {
      let result;
      
      switch (type) {
        case 'products':
          if (productId) {
            // Export d'un produit spécifique
            if (format === 'excel') {
              result = await exportService.exportSingleProductToExcel(productId);
            } else if (format === 'pdf') {
              result = await exportService.exportSingleProductToPDF(productId);
            }
          } else {
            // Export de tous les produits avec filtres
            if (format === 'excel') {
              result = await exportService.exportProductsToExcel(filters);
            } else if (format === 'pdf') {
              result = await exportService.exportProductsToPDF(filters);
            }
          }
          break;
          
        case 'categories':
          if (format === 'excel') {
            result = await exportService.exportCategoriesToExcel(filters.includeInactive);
          }
          break;
          
        case 'quotes':
          if (format === 'excel') {
            result = await exportService.exportQuotesToExcel(filters);
          }
          break;
          
        case 'stats':
          if (format === 'pdf') {
            result = await exportService.exportStatsToPDF();
          }
          break;
          
        default:
          throw new Error('Type d\'export non supporté');
      }
      
      if (result.success) {
        if (onSuccess) onSuccess();
      } else {
        throw new Error(result.error || 'Erreur lors de l\'export');
      }
      
    } catch (error) {
      console.error('Erreur d\'export:', error);
      if (onError) {
        onError(error.message || 'Erreur lors de l\'export');
      } else {
        alert(error.message || 'Erreur lors de l\'export');
      }
    } finally {
      setIsExporting(false);
    }
  };

  const getButtonLabel = () => {
    if (isExporting) {
      return `Export ${format?.toUpperCase()}...`;
    }
    
    if (label) {
      return label;
    }
    
    const typeLabels = {
      products: productId ? 'Produit' : 'Produits',
      categories: 'Catégories',
      quotes: 'Demandes de devis',
      stats: 'Statistiques'
    };
    
    const formatLabels = {
      excel: 'Excel',
      pdf: 'PDF'
    };
    
    return `Exporter ${typeLabels[type]} en ${formatLabels[format]}`;
  };

  return (
    <button
      className={`export-button ${className}`}
      onClick={handleExport}
      disabled={isExporting}
      title={getButtonLabel()}
    >
      {isExporting ? (
        <i className="fas fa-spinner fa-spin"></i>
      ) : (
        <i className={icon}></i>
      )}
      <span>{getButtonLabel()}</span>
    </button>
  );
};

export default ExportButton;
